module.exports = __webpack_public_path__ + "static/media/tok.e0ca1cc9.png";